import React from "react";
import { Link } from "react-router-dom";
import { fetchIdFromUrl, getImageUrl } from "../util/helper";

const FoodSections = ({ title, recipeList, size }) => {
  if(recipeList === undefined) {
    return <div>No Data to show</div>
  }
  return (
    <div className="max-w-7xl mx-auto lg:w-4/5 w-11/12 text-md py-5 space-y-5">
      <h2 className="lg:text-3xl text-2xl font-semibold text-center">{title}</h2>
      <div className="grid md:grid-cols-3 grid-cols-2 gap-5 py-5 lg:gap-8">
        {recipeList.slice(0, size).map((elem, index) => {
          const { images, label } = elem.recipe;
          const url = elem._links.self.href;
          const id = fetchIdFromUrl(url)
          return (
            <Link key={index} to={"/recipes/"+id}>
            <div className="cursor-pointer lg:w-4/5 w-11/12 mx-auto">
              <img
                src={getImageUrl(images)}
                alt={label}
                title={label}
                className=" w-full rounded-2xl bg-red-100 flex flex-shrink-0 "
              />
            <p className="text-sm sm:text-base md:text-lg lg:text-xl">{label}</p>
            </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default FoodSections;
